import { AxiosResponseHeaders } from 'axios';
import { PostDocumentResponseDTO } from '../entities';

const postDocumentResponseDTOToPostDocumentAdapter = (
  data: PostDocumentResponseDTO,
  headers?: AxiosResponseHeaders,
) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { postDocumentResponseDTOToPostDocumentAdapter };
